<template>
  <div class="selection-wrapper">
<span class="level-selection__hex level-selection__sample"
      v-if="selectionValue( 'hex', selectedID )" :style="{ backgroundColor:selectionValue('hex', selectedID )}">
            </span>
    <span class="level-selection__image level-selection__sample" v-else>
            <img :src="selectionValue( 'image', selectedID )[0]" :width="selectionValue( 'image', selectedID )[1]"
                 :height="selectionValue( 'image', selectedID )[0]"
                 :alt="selectionValue( 'name', selectedID)">
            </span>
    <span class="level-selection__name"> {{ selectionValue( 'name', selectedID ) }}</span>
  </div>
</template>

<script>

export default {
  props: [ 'selections', 'selectedID' ],
  methods: {
    selectionValue( field, index ) {
      if ( this.selections[ index ] ) {
        return this.selections[ index ][ field ];
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
@import 'src/scss/selection-sample.scss';
</style>
